<template>
  <div class="card-container">
    <a-tabs v-model:activeKey="activeKey" type="card" @tabClick="tabChange">
      <a-tab-pane v-for="item in otaTab" :key="item.ota_id">
        <template #tab>
          <a-badge
              :count="item.name == '全部' ? 0 : item.count"
              :number-style="{
              height: '12px',
              lineHeight: '12px',
              transform: 'scale(0.9)',
            }"
              :offset="[15, -12]"
          >
            <div>{{ item.name }}</div>
          </a-badge>
        </template>
      </a-tab-pane>
    </a-tabs>
    <div class="content-table">
      <!-- 搜索 -->
      <div ref="topDom" class="header-bar">
        <div class="bar-lef">
          <div class="lef-group">
            <div class="group-one">
              <a-select
                  v-model:value="searchForm.rentType"
                  allowClear
                  placeholder="房源状态"
                  @change="getTableData"
              >
                <a-select-option :value="0">已下线</a-select-option>
                <a-select-option :value="1">已上线</a-select-option>
                <a-select-option :value="3">待发布</a-select-option>
              </a-select>
            </div>
            <div class="group-one">
              <a-select
                  v-model:value="searchForm.type_pms"
                  allowClear
                  placeholder="关联状态"
                  @change="getTableData"
              >
                <a-select-option :value="1">已关联</a-select-option>
                <a-select-option :value="0">未关联</a-select-option>
              </a-select>
            </div>
            <div class="group-one">
              <a-select
                  v-model:value="searchForm.cota_id"
                  :dropdownMatchSelectWidth="false"
                  allowClear
                  placeholder="不限账号"
                  @change="getTableData"
                  @dropdownVisibleChange="GetOtaList"
              >
                <a-select-option
                    v-for="(item, index) in OtaList"
                    :key="index"
                    :value="item.cota_id"
                >{{ item.name }}
                </a-select-option
                >
              </a-select>
            </div>
          </div>

          <div class="search-tips">
            <div class="tip-one">
              已关联：<span class="f-c-000">{{ dataSource.rela }}</span>
            </div>
            <div class="tip-one">
              未关联：<span class="f-c-000">{{ dataSource.rela_un }}</span>
            </div>
          </div>
        </div>
        <div class="bar-rig">
          <div class="rig-one">
            <a-input-search
                v-model:value="searchForm.house_name"
                :loading="searchLoading"
                allowClear
                placeholder="请输入房源名称"
                @search="getTableData"
            >
            </a-input-search>
          </div>

          <div class="rig-one">
            <a-button class="btn-primary" @click="openModal()"
            >读取新房源
            </a-button
            >
          </div>
        </div>
      </div>

      <!-- 读取订单 -->
      <Reading :params="params" @refresh="refresh"/>

      <!-- 表格 -->
      <a-table
          :columns="columns"
          :dataSource="dataSource.list"
          :loading="searchLoading"
          :pagination="false"
          :scroll="{ y: tableHeight }"
          class="table"
          size="small"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key == 'coverMedia'">
            <img
                :src="record.coverMedia ? record.coverMedia : record.logo"
                alt="房源图片"
                fit="fill"
                style="width: 50px; height: 30px; object-fit: cover"
            />
          </template>
          <template v-if="column.key == 'rentType'">
            <div v-if="record.rentType == 0">已下线</div>
            <div v-else-if="record.rentType == 1" class="f-c-green">已上线</div>
            <div v-else>待发布</div>
          </template>
          <template v-if="column.key == 'hname'">
            <div v-if="record.type_pms == 1">
              {{ record.hname }}
            </div>
            <div v-else-if="record.type_pms == 2">{{ record.rrname }}</div>
            <div v-else>-</div>
          </template>
          <template v-if="column.key == 'name'">
            <div>
              <a-avatar
                  :size="25"
                  :src="record.logo"
                  style="width: 25px"
              ></a-avatar>
              {{ record.ota_name }}-{{ record.name }}
            </div>
          </template>
          <template v-if="column.key == 'hid'">
            <div v-if="record.hid" class="f-c-green">已关联</div>
            <div v-else>未关联</div>
          </template>
          <template v-if="column.key == 'operate'">
            <template v-if="record.hid">
              <a-button type="link" @click="handleDelRela(record)"
              >解除关联
              </a-button
              >
              <a-button type="link" @click="goRouter(record)"
              >查看房价
              </a-button
              >
            </template>
            <template v-else>
              <a-button type="link" @click="handleReal(record)">关联</a-button>
            </template>
            <!-- <a-button type="link">预览</a-button> -->
            <a-button
                v-if="!record.loading"
                type="link"
                @click="refreshReal(record)"
            >刷新
            </a-button
            >
            <span v-else><redo-outlined spin style="color: #1890ff"/></span>
          </template>
        </template>
      </a-table>

      <!-- 分页 -->
      <MyPagination
          v-if="refreshPag"
          :pageTotal="pageTotal"
          @onShowSizeChange="onShowSizeChange"
          @pageChange="pageChange"
      />
    </div>
  </div>
</template>
<script>
import {createVNode, nextTick, onMounted, reactive, toRefs, watch} from "vue";
import store from "@/store/pms/landlord/index"; //VUEX
import useUtils from "@/hooks/useUtils.js"; //工具库
import usePagination from '@/hooks/usePagination'; // 分页hook
import {otaCompanyOta, otaDelHouseRela, otaGetComOtaList, otaHouse, otaSyncRoom,} from "@/api/api"; //接口
import {message, Modal} from "ant-design-vue";
import {ExclamationCircleOutlined, RedoOutlined} from "@ant-design/icons-vue";
import router from "@/router/index";
import Reading from "@/components/pms/landlord/Reading/Reading.vue";

export default {
  components: {
    Reading,
    RedoOutlined,
  },
  setup() {
    let {imgCut, countTable} = useUtils();

    let modal = reactive({
      // 父子组件
      params: {
        title: "读取房源",
        sync_ids: "1",
        show: false,
      },
      openModal() {
        modal.params.show = true;
      },
      refresh() {
        table.getTableData();
      },
    });

    let tabs = reactive({
      activeKey: "",
      otaTab: [],
      otaCompany() {
        otaCompanyOta({type: 2}).then((res) => {
          tabs.otaTab = res.data.data;
        });
      },
      tabChange(e) {
        search.searchForm.ota_id = e;
        search.searchForm.start = 0;
        search.searchForm.limit = store.getters.getPageSize;
        pagination.refreshPag = false;
        nextTick(() => {
          pagination.refreshPag = true;
        });
        table.getTableData();
      },
    });

    let search = reactive({
      OtaList: [],
      GetOtaList() {
        if (!search.OtaList.length) {
          otaGetComOtaList().then((res) => {
            search.OtaList = res.data;
          });
        }
      },

      topDom: "",
      searchForm: {
        cota_id: [],
        house_name: "",
        rentType: 1,
        type_pms: [],

        start: 0,
        limit: store.getters.getPageSize,
      },
    });

    let table = reactive({
      tableHeight: "",
      companyLogo: JSON.parse(sessionStorage.getItem("companyInfo") || '{}').logo || '',
      searchLoading: false,
      getTableData() {
        table.searchLoading = true;
        let type_pms = "";
        if (search.searchForm.type_pms == [1]) {
          type_pms = "1,2";
        } else if (search.searchForm.type_pms == [0]) {
          type_pms = 0;
        } else {
          type_pms = "";
        }
        otaHouse({
          ota_id: search.searchForm.ota_id,
          cota_id: search.searchForm.cota_id,
          house_name: search.searchForm.house_name,
          rentType: search.searchForm.rentType,
          type_pms: type_pms,
          start: search.searchForm.start,
          limit: search.searchForm.limit,
        }).then((res) => {
          table.dataSource = res.data;
          pagination.pageTotal = res.data.count;
          table.searchLoading = false;
        });
      },
      dataSource: [],
      columns: [
        {
          title: "图片",
          dataIndex: "coverMedia",
          key: "coverMedia",
          width: 70,
        },
        {
          title: "房源名称",
          dataIndex: "title",
          key: "title",
          ellipsis: true,
          width: 200,
        },
        {
          title: "渠道账号",
          dataIndex: "name",
          key: "name",
          width: 150,
        },
        {
          title: "房源状态",
          dataIndex: "rentType",
          key: "rentType",
          width: 100,
        },
        {
          title: "关联状态",
          dataIndex: "hid",
          key: "hid",
          width: 100,
        },
        {
          title: "类型",
          dataIndex: "type_pms",
          key: "type_pms",
          ellipsis: true,
          width: 100,
          customRender: ({text}) => {
            if (text == 1) {
              return "房间";
            } else if (text == 2) {
              return "房型";
            } else {
              return "-";
            }
          },
        },
        {
          title: "关联房间/房型",
          dataIndex: "hname",
          key: "hname",
          ellipsis: true,
          width: 200,
        },
        {
          title: "操作",
          dataIndex: "operate",
          key: "operate",
          width: 300,
        },
      ],
      handleDelRela(item) {
        Modal.confirm({
          title: "确定要解除关联吗？",
          content: "解除关联后，您可在 房源关联 页面将其关联到其他房间。",
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            otaDelHouseRela({id: item.id}).then((res) => {
              message.success(res.msg);
              table.getTableData();
              tabs.otaCompany();
            });
          },
        });
      },
      handleReal() {
        router.push("/pms/landlord/ota/otarela");
      },
      refreshReal(record) {
        record.loading = true;
        otaSyncRoom({
          cota_id: record.cota_id,
        })
            .then((res) => {
              message.success(res.msg);
            })
            .finally(() => {
              setTimeout(() => {
                record.loading = false;
              }, 1000);
            });
      },
      goRouter(params = {}) {
        if (params.type_pms == 1) {
          router.push({
            path: "/pms/landlord/house/details",
            query: {hid: params.hid, tab: 3},
          });
        } else {
          router.push({
            path: "/pms/landlord/room/details",
            query: {rid: params.hid, tab: 3},
          });
        }
      },
    });

    // 分页;
    let pagination = usePagination(table.getTableData, search.searchForm);

    watch(
        () => store.state.ContentHeight,
        () => {
          table.tableHeight = countTable(search.topDom) - 60;
        }
    );

    onMounted(() => {
      table.getTableData();
      tabs.otaCompany();
      table.tableHeight = countTable(search.topDom) - 60;
    });

    return {
      ...toRefs(tabs),
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(modal),
      ...toRefs(pagination),
      imgCut,
    };
  },
};
</script>

<style lang="scss" scoped>
.content-table {
  background-color: #fff;
  padding: 10px;
}

.search-tips {
  margin-left: 20px;
  display: flex;

  .tip-one {
    margin: 0 10px;
  }
}
</style>

<style lang="scss" scoped>
.card-container > .ant-tabs {
  height: 40px;
}

.card-container > .ant-tabs-card > .ant-tabs-nav::before {
  display: none;
}

.card-container > .ant-tabs-card .ant-tabs-tab,
[data-theme="compact"] .card-container > .ant-tabs-card .ant-tabs-tab {
  background: #ececec;
  border-color: transparent;
  height: 40px;
  margin-right: 10px;
  border-radius: 5px 5px 0 0 !important;
}

.card-container > .ant-tabs-card .ant-tabs-tab-active,
[data-theme="compact"] .card-container > .ant-tabs-card .ant-tabs-tab-active {
  background: #fff;
  border-color: #fff;
}
</style>
